<!-- @format -->

@if (plannedPeriodCount(); as plannedPeriodCount) {
  <sis-study-notification-box *transloco="let t" [type]="'info'">
    <div class="multi-period-info">
      <span>{{ t("TIMELINE.MULTI_PERIOD_TIMING.INFO", { count: plannedPeriodCount }) }}</span>
      <sis-button [link]="true" (clicked)="openPlannedPeriodsDialog()">{{ t("SIS_COMPONENTS.STUDY.SHOW_INFO") }}</sis-button>
    </div>
  </sis-study-notification-box>
}
